import { useState } from "react";
import "./Nav.css";
import { NavBar_menu } from "../../functions/DefaultValues";
import { NavLink } from "react-router-dom";
import { Logo } from "../../Module_Exporter/Module_Exporter";
const Nav = (props)=>{

   const [menu_btn_state,set_menu_btn_state]=useState(false);

   const [menu_items,set_menu_items]=useState(NavBar_menu);

   

    return (<>
      
      <nav id="main_nav_bar"   className={props.sticky===true?"sticky_nav_bar":"Nothing"} >
       
       <div className="brand_section">
        <div className="logo_container">
            <img src={Logo} alt="codesperix" />
            {/* <a href="/home" className="heading">Code<span>Phoenix</span></a> */}
        </div>
        <div className="toggle_menu_btn">
            <i className={menu_btn_state===false?"fas fa-bars":"opacity_off fas fa-bars"} onClick={()=>set_menu_btn_state(!menu_btn_state)} ></i>
           
            <i className={menu_btn_state===false?"opacity_off fas fa-times":"fas fa-times"} onClick={()=>set_menu_btn_state(!menu_btn_state)} ></i>  
        </div>
       </div> 
       <div className={menu_btn_state===false?"menu_section":"show_side_bar_menu menu_section"}>

        <ul id="Nav_menu">
           {
            menu_items.map((items,index)=> <li  key ={index+Math.random()} className="nav_menu_items">
            <NavLink className={({ isActive, isPending }) =>
    isPending ? "pending" : isActive ? "active" : ""
  } to={items.url}>{items.title}
            <div className="nav_items_bars">
             <div className="bar1"></div>
             <div className="bar2"></div>
             <div className="bar3"></div>
            </div>
            </NavLink>
         
        </li>)
           }
        </ul>   


       </div>
        


      </nav>



    </>)
}

Nav.defaultProps={
    sticky:false
}
export default Nav;



